import { useEffect } from "react";

const useModalClose = (ref, onClose) => {
    useEffect(() => {
        if (!onClose) return;

        const getTopModal = () => {
            const modals = document.querySelectorAll(".modal");
            return modals[modals.length - 1];
        };

        const handleKeyDown = (event) => {
            if (event.key !== "Escape") return;

            const currentModal = ref.current;
            const topModal = getTopModal();

            // Nur das oberste Modal darf auf ESC reagieren
            if (currentModal !== topModal) {
                return;
            }

            onClose();
        };

        const handleClickOutside = (event) => {
            const currentModal = ref.current;

            if (!currentModal) return;

            // Klick innerhalb des aktuellen Modals
            if (currentModal.contains(event.target)) {
                return;
            }

            // Klick innerhalb eines anderen Modals
            const clickedModal = event.target.closest(".modal");

            if (clickedModal) {
                return;
            }

            // Nur das oberste Modal darf geschlossen werden
            const topModal = getTopModal();

            if (currentModal !== topModal) {
                return;
            }

            onClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, onClose]);
};

export default useModalClose;